export const SUPPLIER_INVITES_PAGE_TITLE = 'Supplier Invites'

export const PENDING_INVITES_TAB_LABEL = 'Pending Supplier Invites'
export const DEFAULT_SUPPLIERS_TAB_LABEL = 'Default Suppliers'

export const PENDING_INVITES_GUIDANCE =
  'Your job: resolve each supplier invite within about one business day. Add the supplier and upload their price file, then mark the invite as resolved — we will email the venue team so they can start ordering.'

export const DEFAULT_SUPPLIERS_GUIDANCE =
  'Your job: chase the supplier for a proper price file → upload the price file to OMS → turn off the default supplier (red X) in the venue suppliers tab. The row disappears once default pricing is switched off. Target turnaround: 24–48 hours.'

export const DEFAULT_SUPPLIERS_SEARCH_PLACEHOLDER = 'Search by supplier name...'

export const DEFAULT_SUPPLIERS_NO_SEARCH_RESULTS =
  'No default suppliers match your search.'
